// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"277":"2dbb3a2e","796":"c7ccbb57"}[chunkId] + ".chunk.css";
};